export default "__VITE_ASSET__DtsXu6OD__"